module.exports = __webpack_public_path__ + "img/2_79.04854f94.png";